module.exports = __webpack_public_path__ + "static/media/female-red-v3@2x.5d7a2bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/female-red-v3@2x.png
// module id = 76
// module chunks = 0